import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const FilterIcon = ({size, color, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '11';
			case SIZE.STANDARD:
				return '15';
			default:
				return '15';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '11';
			case SIZE.STANDARD:
				return '15';
			default:
				return '15';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg width={getWidth(size)} height={getHeight(size)} viewBox="0 0 15 15">
				<path
					fill={color}
					fillRule="evenodd"
					d="M2.596 3.75L7.5 5.928l4.903-2.18L7.5 1.57 2.596 3.75zM7.5 7.5a.753.753 0 0 1-.304-.065l-6.75-3a.75.75 0 0 1 0-1.37l6.75-3a.749.749 0 0 1 .608 0l6.75 3a.749.749 0 0 1 0 1.37l-6.75 3a.753.753 0 0 1-.304.064zm3.75 2.722v1.649l-3.44 1.563a.754.754 0 0 1-.599.009L3.751 12v-1.625l3.736 1.557 3.763-1.71zm1.875-3.852v1.649L7.81 10.434a.754.754 0 0 1-.599.01L1.875 8.218V6.594l5.612 2.338 5.638-2.562z"
				/>
			</svg>
		</StyledSpan>
	);
};

FilterIcon.SIZE = SIZE;
FilterIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

const StyledSpan = Styled.span`
	display: inline;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
